import { useMemo } from 'react';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { usePrivateWorkspaceAgentSessionGet } from '~/components/v2/components/workspace/workspace-agent-panel/queries/usePrivateWorkspaceAgentSessionGet';

export const useIsActiveWorkspaceAgentSessionArchived = () => {
  const { sessionId, sessions, workspaceId } = usePrivateWorkspaceAgentPanelSession();
  const statusFromList = useMemo(
    () => (sessionId === null ? undefined : sessions.find((session) => session.id === sessionId)?.status),
    [sessionId, sessions],
  );

  const isSessionGetEnabled = sessionId !== null && statusFromList === undefined;

  const {
    data: sessionFromGet,
    isFetching: isSessionGetFetching,
    isPending: isSessionGetPending,
  } = usePrivateWorkspaceAgentSessionGet(
    { sessionId: sessionId ?? undefined, workspaceId },
    { enabled: isSessionGetEnabled },
  );

  return useMemo(() => {
    const status = statusFromList ?? sessionFromGet?.status;
    const isActiveSessionArchived = status === 'archived';
    const isActiveSessionArchiveStatusPending =
      sessionId !== null &&
      statusFromList === undefined &&
      isSessionGetEnabled &&
      status === undefined &&
      (isSessionGetPending || isSessionGetFetching);

    return { isActiveSessionArchived, isActiveSessionArchiveStatusPending };
  }, [
    isSessionGetEnabled,
    isSessionGetFetching,
    isSessionGetPending,
    sessionFromGet?.status,
    sessionId,
    statusFromList,
  ]);
};
